import React from "react";
import { Container } from "@mui/material";
import SiteManagement from "../components/storage/sites/SiteManagement";

const ClientStorageManagement: React.FC = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        padding: "0 !important",
        margin: "0 !important",
        maxWidth: "100% !important",
      }}
    >
      <SiteManagement/>
    </Container>
  );
};

export default ClientStorageManagement;
